<template>
  <SplashWrapper
    :hide-buttons="true"
    :hide-logo="isExpert"
    title="Forgot Password"
    :narrow-page="true"
  >
    <iRow :width="400">
      <iColumn gap="extraLarge">
        <iRow>
          <iText variant="subtle">
            Reset your password
          </iText>
        </iRow>

        <iRow>
          <iColumn gap="large">
            <iTextInput
              v-model="userAuthEmail"
              label="Email address: "
              name="email"
              label-position="above"
              type="email"
              disabled
              width="fill"
              right-icon="pencil"
              @click-icon-right="gotToChangeEmail"
            />

            <iButton
              v-if="!emailSent"
              variant="primary"
              :disabled="!hasValidUserAuthEmail"
              width="fill"
              @click="submitForgotPasswordForm"
            >
              Submit
            </iButton>

            <iText v-if="emailSent">
              {{ confirm }}
            </iText>
          </iColumn>
        </iRow>
      </iColumn>
    </iRow>
  </SplashWrapper>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useUserStore } from "@/stores/user-store";
import { SEND_EMAIL_TIMER_DURATION } from "@/constants/timer-constants";
import SplashWrapper from "@/components/splash/SplashWrapper";
import { EMAIL_FORM } from "@/constants/login-flow-constants";

export default {
  name: "ForgotPasswordForm",
  components: { SplashWrapper },
  inject: ["intent"],
  data() {
    return {
      resendTimer: 0,
      emailSent: false,
      emailError: null,
      resendEmailInterval: null,
    };
  },
  computed: {
    ...mapWritableState(useUserStore, [
      "userAuthEmail",
      "userFlowSteps",
    ]),
    ...mapState(useUserStore, [
      "hasValidUserAuthEmail",
    ]),
    confirm: function () {
      if (this.emailSent) {
        return `An email has been sent to ${this.userAuthEmail}.` +
          `If you have not received the email you may click resend in ${this.resendTimer}(s)`;
      } else {
        return null;
      }
    },
    isExpert() {
      return this.intent === "expert";
    },
  },
  beforeUnmount() {
    clearInterval(this.resendEmailInterval);
  },
  // mounted() {
  //   if (this.$refs.email.focus) {
  //     this.$refs.email.focus();
  //   }
  // },
  methods: {
    ...mapActions(useUserStore, [
      "forgotPassword",
    ]),
    async submitForgotPasswordForm() {
      if (!this.hasValidUserAuthEmail) {
        return;
      }
      this.resetTimer();
      await this.forgotPassword(this.userAuthEmail);
      this.emailSent = true;
    },
    resetTimer() {
      this.resendTimer = SEND_EMAIL_TIMER_DURATION;
      this.resendEmailInterval = setInterval(this.timerTick, 1000);
    },
    timerTick() {
      this.resendTimer--;
      if (this.resendTimer <= 0) {
        this.resendTimer = 0;
        this.emailSent = false;
      }
    },
    gotToChangeEmail() {
      this.userFlowSteps = [EMAIL_FORM];
    },
  },
};
</script>
